// import { useState } from "react";
import { useAtom } from "jotai";
import { consultationJSONAtom } from "../constants/_constant";
import "../css/ConsultationFields.css";
import ConsultationAdviceDirection from "./ConsultationAdviceDirection";
import ConsultationMedicineTable from "./ConsultationMedicineTable";
import ConsultationNextVisit from "./ConsultationNextVisit";
import ConsultationVitals from "./ConsultationVitals";
import CustomField from "./CustomField";
import Observation from "./Observation";
// import { useParams } from "react-router-dom";
// import { useItemsFilter } from "../../_helper/actions/app/items";
// import { ApiEndPoint } from "../../_helper/constant/api-types";
// import { useAtom } from "jotai";
// import { clinicAtom } from "../../_helper/constant/constant-atom";

const ConsultationFields = ({
  medicineData,
  setMedicineData,
  // userId,
  // slotId,
  // consultationId,
  billingServices,
  setBillingServices,
  customfields,
  setCustomfields,
  allergies,
  setAllergies,
  patientHistory,
  setPatientHistory,
  advices,
  setAdvices,
  nextVisit,
  setNextVisit,
  vitals,
  setVitals,
  addictions,
  setAddictions,
  previousVisits,
  handleSaveConsultation,
  readingLoading,
  setObservation,
  observation,
}) => {
  const [consultationJSON] = useAtom(consultationJSONAtom);
  // const { userId, slotId, consultationId } = useParams();
  // const [medicineData, setMedicineData] = useState([]);
  // const [customfields, setCustomfields] = useState([]);
  // const [allergies, setAllergies] = useState([]);
  // const [patientHistory, setPatientHistory] = useState([]);
  // const [advices, setAdvices] = useState(null);
  // const [nextVisit, setNextVisit] = useState("");
  // const [clinic] = useAtom(clinicAtom);

  // const { data: consultationData } = useItemsFilter(
  //   ApiEndPoint.QP_CM_CONSULTATION_DATA,
  //   `?action=getConsultationData&frontend=True&clinic_id=${clinic?.id}&id=${consultationId}`
  // );

  // let vitals;
  // if (consultationData?.length > 0) {
  //   vitals = consultationData[0]?.qp_cm_vitals;
  // }
  // //(customfields, 'sdaljkl1')

  return (
    <div className="cu-consultation-fields-container">
      {consultationJSON?.map((data) => {
        if (data?.key === "vitals") {
          return (
            <ConsultationVitals
              key={data.id}
              vitals={vitals}
              setVitals={setVitals}
              previousVisits={previousVisits}
              handleSaveConsultation={handleSaveConsultation}
              readingLoading={readingLoading}
            />
          );
        }
        if (data?.key === "medicineTable") {
          return (
            <ConsultationMedicineTable
              key={data.id}
              medicineData={medicineData}
              setMedicineData={setMedicineData}
            />
          );
        }
        if (data?.key === "adviceDirection") {
          return (
            <ConsultationAdviceDirection
              key={data.id}
              advices={advices}
              setAdvices={setAdvices}
            />
          );
        }
        if (data?.key === "nextVisit") {
          return (
            <ConsultationNextVisit
              key={data.id}
              nextVisit={nextVisit}
              setNextVisit={setNextVisit}
            />
          );
        }
        if (data?.key === "observation") {
          return (
            <Observation
              key={data.id}
              setObservation={setObservation}
              observation={observation}
            />
          );
        }
        return (
          <CustomField
            key={data?.id}
            data={data}
            customfields={customfields}
            setCustomfields={setCustomfields}
            allergies={allergies}
            setAllergies={setAllergies}
            patientHistory={patientHistory}
            setPatientHistory={setPatientHistory}
            addictions={addictions}
            setAddictions={setAddictions}
            billingServices={billingServices}
            setBillingServices={setBillingServices}
          />
        );
      })}
    </div>
  );
};

export default ConsultationFields;
